module.exports = __webpack_public_path__ + "static/media/creativ1.f87fac73.jpg";